import { BaseObject } from './../shared/baseClass';


export class Website extends BaseObject {
    public sectionOrder: string[];
    public siteName:string;
    public weddingEvents: WeddingEvent[];
    public rsvpResponses: RsvpResponse[];
    public layout:string;
    public template:string;
    public colors:{
        light: string;
        dark: string;
        lightAccent: string;
        darkAccent: string;
        accent:string
    }

    public tags:string[]
    
    
    public welcome: {
        eventEndDateUtc: { year: number; month: number; day: number; };
        eventEndDate: Date;
        heroImageUrl: string;
        heroImageUrlEnabled : boolean;
        eventDisplayName: string;
        eventDisplayNameTranslation:string;
        greetings: string;
        greetingsTranslation:string;
        eventDate: Date;
        eventDateUtc: {year: number, month: number, day: number};    
        eventLocation: string;
        isEnabled : boolean;
        sectionName: string;
        updated: boolean;
        rsvpDeadline: Date;
        rsvpDeadlineDateUtc: {year: number, month: number, day: number};
        rsvpShortNote: string;
        rsvpShortNoteTranslation: string;
    };
    public story: {
        imageGrid: string;     
        storyText: string;
        storyTextTranslation:string;
        storyHighlight: string;
        storyHighlightTranslation: string;
        sectionName :string;
        sectionNameTranslation:string;
        isEnabled : boolean;
        imageUrl: string;
        imageUrl2: string;
        imageUrl3: string;
        imageUrl4: string;
        imageUrl5: string;
        imageUrl6: string;
        imageEnabled: boolean;
        updated: boolean;
    };
    public rsvp: {     
      
        sectionName :string;
        sectionNameTextTranslation:string;
        isEnabled : boolean;
     
    };
    
    public announcement: {
        headline: string;
        headlineTranslation:string;
        message: string;        
        messageTranslation:string;
        isEnabled : boolean;
        sectionName :string;
    
    };

    public schedule: {
        scheduleItems: ScheduleItem[];
        isEnabled : boolean;
        sectionName: string;
        sectionNameTranslation:string;
        updated: boolean;
    };

    public weddingParty: {
        partyMembers: PartyMember[];
        isEnabled : boolean;
        sectionName: string;
        sectionNameTranslation:string;
        intro:string;
        introTranslation:string;
    };
    
    public travel: {
        travelInfo: TravelInfo[];
        isEnabled : boolean;
        sectionName: string;
        
        sectionNameTranslation:string;
    };

    public questions:{
        questions: Question[];
        isEnabled : boolean;
        sectionName: string;
        sectionNameTranslation:string;
    };

    
    
    public registry:{
        registryItems: RegistryItem[];
        isLinkedtoHitchd: boolean;

        isEnabled : boolean;
        sectionName: string;
        leadInText:string;
        leadInTextTranslation:string;
        buttonText:string;
        buttonTextTranslation:string;
        sectionNameTranslation:string;
    };
    

    public id: string;
    public fonts:{
        heading:string;
        paragraph:string;
        misc: string;
    }
    
    public uploadedFonts : string[];
  style: string;
  defaultMode: boolean;
  paid:boolean;
  isLive: boolean;
  colorsMinimalTemplateDefault: { light: string; dark: string; };
  hasViewedPreview: boolean;
    
}

    

    export class Guest  extends BaseObject{
        firstName: string;
        lastName: string;
        partyName: string;
        tags: string[];
        isPlusOneTo: string;
        dietaryRequirements: string;
        phoneNumber: string;
        email: string;      
        isChild: boolean
        id: string;
        selected: boolean;
        rsvpStatus: { [eventId: string]: string };
        notes: string;
        rsvpResponses: Record<string, string>;
        canBringPlusOne: boolean;
        plusOneFirstName: string;
        plusOneLastName: string
    }

 



export class Question{
    title: string;
    titleTranslation: string;
    text: string;
    textTranslation: string;
}


export class TravelLink{
    description: string;
    descriptionTranslation: string;
    url: string;
}


export class TravelInfo {
    public title: string;
    public titletranslation: string;
    public travelType : string = 'flight, hotel, house / rental, hotel accommodation, tents, campsite / tent, rental car, rideshare / taxi, bus, train, ferry, boat, travel note,';
    public notes: string;
    public notesTranslation: string;
    public url: string;
    public address: string;
    public phone: string;
    public flightNumber: string;
    public discountCode: string;
    public travelLinks: TravelLink[];


}
export class PartyMember {
    public firstName: string;
    public lastName: string
    public role: string;
    public roleTranslation: string;
    public imageUrl: string;
    public story: string;
    public storyTranslation: string;
    public email: string;
    public phone: string;
}

export class RegistryItem {

   public name: string;
   public url: string;
   public logo:string;
}


export  class ScheduleItem {
  public eventName:string;
  public eventNameTranslation:string;
  public startDate:Date;
  public startDateUtc: {year: number, month: number, day: number};
  public startTime:string;
  public endTime:string
  public endDate:Date;  
  public endDateUtc: {year: number, month: number, day: number};
  public venue:string;
  public venueTranslation:string;
  public address:string;
  public addressTranslation:string;
  public attire:string;
  public attireTranslation:string;
  public description:string;
  public descriptionTranslation:string;
}

export class WeddingEvent extends ScheduleItem   {
    public isPrivate: boolean;
    public attendanceQuestion: RsvpQuestion;
    public collectRsvpsOnWebsite: boolean;
    public rsvpQuestions : RsvpQuestion[];
    public createdDate: number;
    public modifiedDate: number;
    public id:string
    
  }


  export class RsvpQuestion{
    public question: string;
    public questionTranslation: string
    public questionType: string;
    public options: string[];
    public optionsTranslation: string[];
    public id:string;
    public optional: boolean;

  }


  export class RsvpResponse{
    public guestId: string;
    public eventId: string;
    public questionAnswer: { question: string, answer: string }[];
    public createdDate: number;
    public modifiedDate: number;
    public userId: string;
    public id:string

  }
export enum WebsiteSectionType {
    Welcome,
    Story,
    Gallery,
    Registry,
    RSVP,
    Questions,
    Announcement,
    Schedule,
    Travel,
    Accommodation,
}


// WEBPACK FOOTER //
// ./src/app/website-builder/wedding.ts